import { randInt } from '../utils/fractionMath';

const NICE_PAIRS = [
  [1, 2], [1, 3], [1, 4], [1, 5],
  [2, 3], [3, 4], [1, 6], [2, 5],
  [3, 5], [4, 5], [1, 8], [3, 8],
  [5, 8], [1, 10], [3, 10], [7, 10],
];

export function generateTopic3Questions(count = 10) {
  const questions = [];
  for (let i = 0; i < count; i++) {
    const [num, den] = NICE_PAIRS[randInt(0, NICE_PAIRS.length - 1)];
    const multiplier = randInt(1, 10);
    const whole = den * multiplier;
    const answer = (whole / den) * num;

    questions.push({
      id: `t3_${i}`,
      topicId: 3,
      type: 'fraction_of',
      prompt: `Cik ir no skaitļa ${whole}?`,
      data: { num, den, whole },
      correctAnswer: answer,
    });
  }
  return questions;
}
